// Shared helpers for the portfolio fee calculator. computeFeeTotals must
// mirror _compute_fee_totals in app/api/admin.py exactly.

export const MULTIPLIER_KEY = 'direct_series_sub_portfolio_multiplier';

export const FEE_FIELDS = [
  'investment_mgmt_fee',
  'sub_portfolio_mgmt_fee',
  'indirect_costs',
  'aggregate_rebates',
  'transaction_fees',
  'performance_fees',
];

// Fields compared for dirty-tracking / sent on save
export const EDITABLE_FIELDS = ['is_available', 'pds_date', ...FEE_FIELDS];

// Fields copied by the "copy from" action (availability stays the target's own)
export const COPY_FIELDS = ['pds_date', ...FEE_FIELDS];

export const computeFeeTotals = (row, multiplier) => {
  if (!row.is_available) return { total_fixed_cost: null, total_variable_cost: null };

  let totalFixed = (row.investment_mgmt_fee || 0)
    + (row.indirect_costs || 0)
    - (row.aggregate_rebates || 0);
  if (row.sub_portfolio_mgmt_fee != null) {
    totalFixed += row.sub_portfolio_mgmt_fee * multiplier;
  }
  const totalVariable = totalFixed + (row.transaction_fees || 0) + (row.performance_fees || 0);
  return { total_fixed_cost: totalFixed, total_variable_cost: totalVariable };
};

export const formatPercent = (val) => {
  if (val == null) return '';
  return (val * 100).toFixed(4) + '%';
};

export const formatAuditDate = (dateStr) => {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-AU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
};
